// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  apiUrl: 'https://menuload.com/api/',
  // openaiApiKey: 'sk-proj-gn58dQiJUcH4RnNrvLgwT3BlbkFJAfM3dQOoPsxv4bu1EPJN'
  openaiApiKey: 'sk-psychoroom-I4tQJnuGJpHyGWI3ZRDhT3BlbkFJJazhSoI8u2AouD61su1m',

  firebaseConfig: {
    apiKey: "AIzaSyAzpADJ3Qk2YGUp7urLvZAQj_mG__BEtCs",
    authDomain: "menuload-cd311.firebaseapp.com",
    databaseURL: "https://menuload-cd311-default-rtdb.firebaseio.com",
    projectId: "menuload-cd311",
    storageBucket: "menuload-cd311.firebasestorage.app",
    messagingSenderId: "145740019977",
    appId: "1:145740019977:web:61bb6addd913caf7b23bd8"  
  }


};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
